import { LicenseType } from 'types/customer';

export type FormMode = 'create' | 'edit';
export type TransferType = 'full' | 'partial';
export enum SymbolTypeEnum {
    STOCK = 'stock',
    OPTION = 'option',
    MUTUAL_FUND = 'mutualFund'
}
export type BrokerIdType = number | null; // 经纪公司ID, 为null的时候代表other选项

// /api/v1/broker/config/list(经纪公司列表) 中的items得每一项的类型
export interface BrokerData {
    broker: string;
    company: string;
    dtc_number: string;
    // other的时候broker_id为null
    id: BrokerIdType;
    license: LicenseType;
    logo: string;
    account_type: 'Individual' | 'STL' | null;
}

// /api/v1/position/transfer/info 接口的返回数据类型
export interface TransferInfo {
    account_no: string;
    company: string;
    contact_mailbox: string;
    contact_number: string;
    contacts: string;
    dtc_number: string;
    name: string;
}

export enum LongShortEnum {
    LONG = 'long',
    SHORT = 'short'
}

export type TransferSecType = 'STOCK' | 'OPTION' | 'MUTUAL_FUND';

// 股票/期权/基金等可转资产的表单数据类型
export interface TransferAssetFormData {
    type: SymbolTypeEnum;
    symbol: string;
    symbol_name: string;
    long_short: LongShortEnum;
    quantity: string;
    secType: TransferSecType;
    temporarySymbol: string; // 临时的symbol, 用于编辑的时候回显
    cusipNum?: string;
}

// transfer_property_infos字段的类型
export interface TransferPropertyInfoItem {
    symbol: string; // 标的代码
    quantity: number; // 数量
    market: string; // 市场
    secType: TransferSecType; // 标的类型
    longShortInd: 'L' | 'S'; // 做多还是做空
    expiry?: string; // 期权的到期时间
    putCall?: string; // 期权的PUT/ CALL
    strike?: number; // 期权的行权价格
    cusipNum?: string; // CUSIP编号
}

/** 行情接口支持的完整的标的类型 */
enum FullSymbolTypeEnum {
    STOCK = 0,
    PLATE = 1,
    WARRANT = 3,
    IPOT = 4,
    FUTURE = 5,
    OTC = 6,
    INDEX = 7,
    MF = 8,
    CC = 9,
    BOND_YIELD = 10,
    FOREX = 11,
    ETF = 12,
    BOND = 13,
    CFD = 14,
    CORP_BOND = 15
}

export interface SymbolInfo {
    halted: number;
    labels: null;
    market: string;
    nameCN: string;
    symbol: string;
    type: FullSymbolTypeEnum;
}

// 转股方法枚举值
export enum TransferMethodEnum {
    ACATS = 'ACATS', // 全部转股
    ACATS_PARTIAL = 'ACATS_PARTIAL' // 部分转股
}
